import { paths, useAuth } from 'mmfintech-backend-api'
import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

/**
 * Click handler for the brand logo: logged-in users go to the dashboard,
 * everyone else goes to the login page.
 */
export const useLogoNavigation = () => {
  const history = useHistory()
  const userStatus = useAuth()

  return useCallback(() => {
    history.push(userStatus === 'LOGGED_IN' ? paths.dashboard() : paths.login())
  }, [history, userStatus])
}
